import { DealersAndLocationsDropdownKeys } from "components/DealersAndLocationsDropdown/queryKeys";
import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { DealersDashboardQueryKeys } from "modules/DealersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DealerID } from "models";

export const useDeleteDealerMutation = () =>
  useTypedMutation<DealerID, void>({
    mutationFn: async id => {
      await ApiInstance.post("/dealers/delete", { id }, ENV.dealerBaseURL);
    },
    onSuccess: deletedId => {
      const dealers = typedQueryClient.getQueryData(DealersDashboardQueryKeys.list);
      const listDealerIdx = dealers?.findIndex(({ id }) => id === deletedId) ?? -1;

      if (dealers && listDealerIdx !== -1) typedQueryClient.setQueryData(DealersDashboardQueryKeys.list, dealers.toSpliced(listDealerIdx, 1));

      const dealersList = typedQueryClient.getQueryData(DealersAndLocationsDropdownKeys.dealers);
      const dealerIdx = dealersList?.dealers.findIndex(({ id }) => id === deletedId) ?? -1;
      if (!dealersList || dealerIdx === -1) return;

      typedQueryClient.setQueryData(DealersAndLocationsDropdownKeys.dealers, { ...dealersList, dealers: dealersList.dealers.toSpliced(dealerIdx, 1) });
    }
  });
